// Saving a history version (14 Oct 2026): the server makes the copy (functions createVersionSnapshot),
// and the app WAITS for it. A 1,500-cue show took 10 to 50 s from the browser; the copy must still be
// the true before-state of a page op or a promote, so it never runs in the background.
//
// This show's unsent edits first (lib/show-edits-sent.js, bounded): the server reads Firestore, not this tab's store, so this tab's own
// recent edits must have landed before the read. `version` is the name (a user's save), or
// { name, autoSave, autoSaveDetail } for an automatic one, exactly as createVersion takes it.
// `db` and `callable` are passed in so this can be tested without Firebase.
import { waitForShowEditsSent } from './show-edits-sent.js'; // eslint-disable-line import/extensions

// eslint-disable-next-line import/prefer-default-export
export async function saveVersionOnServer({ db, callable, projectId, version }) {
    if (!projectId) throw new Error('Cannot save a version: no project is open.');
    const payload = typeof version === 'string' ? { projectId, name: version } : { projectId, name: version.name };
    if (typeof version !== 'string' && version.autoSave) {
        payload.autoSave = version.autoSave;
        payload.autoSaveDetail = version.autoSaveDetail || '';
    }
    await waitForShowEditsSent({ db, projectId });
    const res = await callable(payload);
    const versionId = res && res.data && res.data.versionId;
    if (!versionId) throw new Error('The server returned no version id.');
    return versionId;
}


// WEBPACK FOOTER //
// ./src/lib/version-save.js